import { computed, inject, Injectable, Signal } from '@angular/core';
import { AuthStore } from './auth.store';
import { IAuthState, IUserState, TRole, USER_META_STATE } from './auth.interface';
import { IPageRenderState } from '../interface/app.interface';

interface IAuthFacade {
  isLoggedIn: Signal<boolean>;
  userMetaState: Signal<USER_META_STATE>;
  isFirstLoadAfterLinkAccount: Signal<boolean>;
  updatePageRenderState(newState: IPageRenderState): void;
  updateAuthState(newAuthState: IAuthState): void;
  updateUserState(newUserState: IUserState): void;
  clearAuthState(): void;
}

@Injectable({
  providedIn: 'root',
})
export class AuthFacade implements IAuthFacade {
  private readonly authStore = inject(AuthStore);

  isLoggedIn: Signal<boolean> = computed(() => {
    return this.authStore.authState().isLoggedIn;
  });

  userRole: Signal<TRole> = computed(() => {
    return this.authStore.authState().userRole;
  });

  userMetaState: Signal<USER_META_STATE> = computed(() => {
    return this.authStore.authState().userState;
  });

  isFirstLoadAfterLinkAccount = computed(() => {
    return this.authStore.pageRenderState().isFirstLoadAfterLinkAccount;
  });

  isFirstLoadOnSuccessNewUser = computed(() => {
    return this.authStore.pageRenderState().isFirstLoadOnSuccessNewUser;
  });

  updatePageRenderState(newState: Partial<IPageRenderState>) {
    this.authStore.updatePageRenderState(newState);
  }

  updateAuthState(newAuthState: Partial<IAuthState>) {
    this.authStore.updateAuthState(newAuthState);
  }

  updateUserState(newUserState: IUserState) {
    this.authStore.updateUserState(newUserState);
  }

  clearAuthState(): void {
    this.authStore.clearState();
  }
}
